
import { Component, Vue } from 'vue-property-decorator'
import { AppMenuAdd } from '@/types/menu'
import { ElForm } from 'element-ui/types/form'
import { pInteger } from '@/utils/validate'

@Component({
  name: 'MenuAdd'
})
export default class extends Vue {
  private title = '新增菜单'

  private info: AppMenuAdd = {
    menuName: '',
    menuWebId: '',
    url: '',
    parentMenuId: '',
    iconPath: '',
    orderNum: '',
    isLeaf: '1'
  }

  private rules = {
    menuName: [{ required: true, message: '请输入菜单名称', trigger: ['blur', 'change'] }],
    parentMenuId: [{ required: true, message: '请选择父级菜单', trigger: ['change'] }],
    menuWebId: [{ required: true, message: '请选择关联菜单', trigger: ['change'] }],
    iconPath: [{ required: true, message: '请输入图标名称', trigger: ['blur', 'change'] }],
    isLeaf: [{ required: true, message: '请选择是否叶子节点', trigger: ['change'] }],
    orderNum: [{ validator: pInteger, trigger: ['blur', 'change'] }]
  }

  private menuList = []
  private webMenuList = []
  private submitShow = false

  created () {
    this.menuListGet()
    this.webMenuGet()
    if (this.$route.params.id) {
      this.title = '编辑菜单'
      this.detailsGet()
    }
  }

  // 详情
  detailsGet () {
    this.$axios.get(this.$apis.menu.appDeteil, {
      menuId: this.$route.params.id
    })
      .then((res) => {
        this.info = {
          menuId: res.menuId,
          menuName: res.menuName,
          menuWebId: res.menuWebId || '',
          url: res.url || '',
          parentMenuId: res.parentMenuId || '',
          iconPath: res.iconPath,
          orderNum: res.orderNum || '',
          isLeaf: res.isLeaf
        }
      })
  }

  // 菜单列表
  menuListGet () {
    this.$axios.get(this.$apis.menu.appPage)
      .then((res) => {
        this.menuList = res.list || []
      })
  }

  // 菜单数据
  webMenuGet () {
    this.$axios.get(this.$apis.version.menuList, {
      versionId: this.$route.params.id || null
    })
      .then((res) => {
        this.webMenuList = res || []
      })
  }

  // 提交保存
  onSubmit () {
    (this.$refs.info as ElForm).validate((valid) => {
      if (valid) {
        this.submitShow = true
        if (this.info.isLeaf !== '1') {
          this.info.parentMenuId = ''
        }
        const url = this.$route.params.id
          ? this.$apis.menu.appUpdate
          : this.$apis.menu.appAdd
        this.$axios.post(url, this.info)
          .then(() => {
            this.submitShow = false
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$router.push({ name: 'menuSetting' })
          })
          .catch(err => {
            this.submitShow = false
            this.$message.error(err)
          })
      }
    })
  }
}
